module.exports = __webpack_public_path__ + "img/attachmentSetting-1@2x.23670b6.png";